import { createContext } from "react";
const InquiryContext = createContext({});
export default InquiryContext;
